import { render } from "./SupportTools.vue?vue&type=template&id=33904531&scoped=true"
import script from "./SupportTools.vue?vue&type=script&lang=js"
export * from "./SupportTools.vue?vue&type=script&lang=js"

import "./SupportTools.vue?vue&type=style&index=0&id=33904531&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33904531"]])

export default __exports__